// Add your custom JS here.





import "./googlereviews.js"; // swiperjs pro HP vypis lektoru
import "./is_store_open_flag.js"; // swiperjs pro HP vypis lektoru


// arrow up
/*
const arrowup = document.getElementById("arrow-up-holder");

window.addEventListener("scroll", () => {
    const scrollposition = window.pageYOffset;

    if (scrollposition > 150) {
        arrowup.classList.add("showarrow");
    } else {
        arrowup.classList.remove("showarrow");
    }


});

window.onscroll = function () { scrollFunction() };
*/


document.addEventListener("DOMContentLoaded", function () {
    const container = document.querySelector("#main");

    if (!container) return;

    const links = container.querySelectorAll("a[href]");

    links.forEach(link => {
        const href = link.getAttribute("href");

        // Přeskoč anchor odkazy a tel/mailto
        if (
            href.startsWith("#") ||
            href.startsWith("mailto:") ||
            href.startsWith("tel:") ||
            href.startsWith("javascript:")
        ) return;

        // Vytvoří URL objekt (pokud není absolutní, použije aktuální doménu)
        let url;
        try {
            url = new URL(href, window.location.origin);
        } catch (e) {
            return; // Neplatný odkaz
        }

        const hostname = url.hostname;
        //console.log("hostname", hostname);
        if (
            hostname &&
            !hostname.endsWith("djishop.cz") &&
            !hostname.endsWith("djishop.sk")
        ) {
            link.setAttribute("target", "_blank");
            link.setAttribute("rel", "noopener noreferrer");
            // console.log("Odkaz neni doménu djishop.cz nebo djishop.sk, nebudu přidávat target a rel.", link.href, link.html);
        } else {
            //console.log("Odkaz neni doménu djishop.cz nebo djishop.sk, nebudu přidávat target a rel.", link.href, link.html);
        }
    });
});
